import Repository from './Repository';

import { vue } from '../main';

const baseUrl = process.env.VUE_APP_API_URL;
const base = `${baseUrl}/media`;

export default {
  /**
   * Searches the available instance bound medie for a given keyword.
   *
   * @param keyword
   * @returns {Promise<AxiosResponse<T>>}
   */
  search(keyword) {
    return Repository.post(`${base}/search`, {
      title: keyword,
    });
  },

  /**
   * Sets the specified medium as the Instance media.
   *
   * @param mediaId
   * @returns {Promise<AxiosResponse<T>>}
   */
  select(mediaId) {
    return Repository.post(`${base}/select`, {
      mediaId,
    });
  },

  /**
   * Removes the instance bound medium.
   *
   * @returns {Promise<AxiosResponse<T>>}
   */
  remove() {
    return Repository.post(`${base}/remove`);
  },
};
